export default __webpack_public_path__ + "static/media/798.d0aae6b2.png";